/**
 * パスワード忘れ
 */
import * as httpConst from '../../../constants/httpConst'
import Vue from 'vue'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/forget`
 
 const forget = {
   namespaced: true,
   state: {},
   getters: {},
   actions: {
      edit ({ commit }, { token }) {
        const api_path = `${API_PATH}/${token}/edit`
        return new Promise((resolve) => {
          Vue.$http.get(api_path).then(data => {
            commit
            resolve(data.content)
          })
        })
      },
     create( { commit, state }, { params } ) {
       return new Promise( ( resolve, _reject) => {
         Vue.$http.post(API_PATH, params).then( data => {
           let content = data.content
           resolve(content)
         } )
       })
     },
     update( {commit, state}, { token, params } ) {
       const api_path = `${API_PATH}/${token}`
       return new Promise( ( resolve, _reject) => {
         Vue.$http.patch(api_path, params).then( data => {
           let content = data.content
           resolve(content)
         } )
       })
     }
   },
   mutations: {},
 }
 
 export default forget